import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export const CHECKOUT_URL = 'https://football-ready.impultienda.ar/checkout';
type CtaButtonProps = {
  label?: string;
  href?: string;
  className?: string;
};
export function CtaButton({
  label = 'Get the Football Ready Pack',
  href = CHECKOUT_URL,
  className = ''
}: CtaButtonProps) {
  const isInternal = href.startsWith('#');
  return <a href={href} target={isInternal ? undefined : '_blank'} rel={isInternal ? undefined : 'noopener noreferrer'} className={`group inline-flex items-center justify-center gap-3 rounded-xl bg-cta px-9 py-5 text-center font-display text-xl font-bold uppercase leading-none tracking-wide text-white shadow-[0_4px_0_0_#009a55] transition-all duration-150 hover:bg-cta-dark hover:shadow-[0_2px_0_0_#007a44] focus:outline-none focus-visible:ring-4 focus-visible:ring-cta/40 active:translate-y-[2px] active:shadow-none sm:text-2xl ${className}`} style={{
    paddingTop: "24px",
    paddingBottom: "24px"
  }} data-id="element-41" data-mp="qk21x8fpjog2">
      <span data-id="element-42" data-mp="35xfprbbzpdce">{label}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 group-hover:translate-x-1" aria-hidden="true" data-id="element-43" data-mp="35y7j0fi46yzi" />
    </a>;
}